import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6504667a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-breadcrumb__area pt-60 pb-60 p-relative z-index-1 fix" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tp-breadcrumb__bg",
  "data-background": "/assets/lms_website/website-assets/img/breadcrumb/breadcrumb-bg-2.jpg"
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = { class: "tp-breadcrumb__content" }
const _hoisted_7 = { class: "tp-breadcrumb__list" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "14",
  viewBox: "0 0 17 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg "
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.07207 0C8.19331 0 8.31107 0.0404348 8.40664 0.114882L16.1539 6.14233L15.4847 6.98713L14.5385 6.25079V12.8994C14.538 13.1843 14.4243 13.4574 14.2225 13.6589C14.0206 13.8604 13.747 13.9738 13.4616 13.9743H2.69231C2.40688 13.9737 2.13329 13.8603 1.93146 13.6588C1.72962 13.4573 1.61597 13.1843 1.61539 12.8994V6.2459L0.669148 6.98235L0 6.1376L7.7375 0.114882C7.83308 0.0404348 7.95083 0 8.07207 0ZM8.07694 1.22084L2.69231 5.40777V12.8994H13.4616V5.41341L8.07694 1.22084Z",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_9 = { class: "color" }
const _hoisted_10 = { class: "tp-breadcrumb__title white" }
const _hoisted_11 = { class: "container py-5" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "layout" }
const _hoisted_14 = { class: "card shadow-sm" }
const _hoisted_15 = { class: "card-body form-progress mb-4" }
const _hoisted_16 = {
  key: 0,
  class: "text-center"
}
const _hoisted_17 = { class: "text-success mt-3" }
const _hoisted_18 = { class: "text-secondary" }
const _hoisted_19 = { class: "info-studant" }
const _hoisted_20 = { class: "section-container" }
const _hoisted_21 = { class: "input-container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_application_date",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Application Date - تاريخ التسجيل"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_23 = { class: "input-container" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "first_name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Name in Arabic - الاسم بالعربي "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_26 = {
  key: 1,
  class: "valid-feedback"
}
const _hoisted_27 = { class: "input-container" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_name_in_english",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Name in English - الاسم بالانجليزي"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_29 = {
  class: "input-container",
  style: {"grid-column":"1 / 3","grid-row":"2"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "student_email_id",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Student Email Address - البريد الالكتروني "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_31 = { class: "form-control-has-icon" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-envelope form-control-icon" }, null, -1 /* HOISTED */))
const _hoisted_33 = {
  class: "input-container",
  style: {"grid-column":"1 / 3","grid-row":"3"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_other_mobile_number",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Other Mobile Number - رقم هاتف آخر")
], -1 /* HOISTED */))
const _hoisted_35 = { class: "form-control-has-icon" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-phone-alt form-control-icon" }, null, -1 /* HOISTED */))
const _hoisted_37 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_38 = {
  key: 1,
  class: "valid-feedback"
}
const _hoisted_39 = { class: "input-container" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "student_mobile_number",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Student Mobile Number - رقم الهاتف "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_41 = { class: "form-control-has-icon" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-phone-alt form-control-icon" }, null, -1 /* HOISTED */))
const _hoisted_43 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_44 = {
  key: 1,
  class: "valid-feedback"
}
const _hoisted_45 = { class: "input-container" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_national_id",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "National ID - الرقم القومي ")
], -1 /* HOISTED */))
const _hoisted_47 = { class: "input-container" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_student_enrollment_code",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Student Enrollment Code - كود الالتحاق ")
], -1 /* HOISTED */))
const _hoisted_49 = { class: "program-info" }
const _hoisted_50 = { class: "section-container" }
const _hoisted_51 = { class: "input-container" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_study_type",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Study Type - نوع الدراسة"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_53 = {
  key: 0,
  class: "form-control form-control-sm readonly-style"
}
const _hoisted_54 = {
  class: "input-container",
  style: {"grid-column":"1 / 3","grid-row":"2"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "program",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Program - البرنامج "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_56 = {
  key: 0,
  class: "form-control form-control-sm bg-light"
}
const _hoisted_57 = { class: "input-container" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_fee_amount",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Fee Amount - مبلغ الرسوم ")
], -1 /* HOISTED */))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_branch_group_timetable_days",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Branch Group Timetable Days - المواعيد "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_60 = { class: "table-rounded-wrapper" }
const _hoisted_61 = {
  class: "table table-sm bg-white",
  style: {"table-layout":"fixed"}
}
const _hoisted_62 = {
  style: {"width":"10%"},
  class: "text-center"
}
const _hoisted_63 = ["checked"]
const _hoisted_64 = { class: "text-center" }
const _hoisted_65 = { class: "text-center" }
const _hoisted_66 = { class: "text-center" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  colspan: "4",
  class: "text-center text-muted"
}
const _hoisted_69 = { class: "text-primary text-center" }
const _hoisted_70 = ["checked"]
const _hoisted_71 = { class: "text-primary text-center" }
const _hoisted_72 = { class: "text-primary text-center" }
const _hoisted_73 = { class: "text-primary text-center" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_courses",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Courses - الدورات"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_75 = { class: "table-rounded-wrapper" }
const _hoisted_76 = {
  class: "table table-sm bg-white",
  style: {"table-layout":"fixed"}
}
const _hoisted_77 = {
  style: {"width":"10%"},
  class: "text-center"
}
const _hoisted_78 = ["checked"]
const _hoisted_79 = {
  style: {"width":"10%"},
  class: "text-center"
}
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = {
  style: {"width":"15%"},
  class: "text-center"
}
const _hoisted_82 = { key: 0 }
const _hoisted_83 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_84 = { class: "text-primary text-center" }
const _hoisted_85 = ["checked"]
const _hoisted_86 = { class: "text-primary text-center" }
const _hoisted_87 = { class: "text-primary text-center" }
const _hoisted_88 = { class: "text-primary text-center" }
const _hoisted_89 = ["checked"]
const _hoisted_90 = { class: "input-container" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_branch",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Branch - الفرع "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_92 = {
  key: 0,
  class: "form-control form-control-sm readonly-style"
}
const _hoisted_93 = {
  key: 2,
  class: "input-container"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_branch_group_timetable",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Branch Group Timetable - اختيار الموعد "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_95 = {
  key: 0,
  class: "form-control form-control-sm readonly-style"
}
const _hoisted_96 = {
  key: 3,
  class: "input-container",
  style: {"grid-column":"3","grid-row":"3"}
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "custom_waiting_month",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Waiting Month - شهر التاجيل"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_98 = ["disabled"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1 /* HOISTED */))
const _hoisted_100 = ["value"]
const _hoisted_101 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_102 = { class: "terms-section" }
const _hoisted_103 = { class: "form-check modern-checkbox" }
const _hoisted_104 = {
  class: "form-check-label",
  for: "infoCheckbox"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */))
const _hoisted_106 = ["disabled"]
const _hoisted_107 = { class: "terms-dialog" }
const _hoisted_108 = { class: "terms-dialog-header" }
const _hoisted_109 = { class: "terms-dialog-title" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-contract me-2" }, null, -1 /* HOISTED */))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1 /* HOISTED */))
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = ["innerHTML"]
const _hoisted_114 = { class: "terms-dialog-footer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CheckMark = _resolveComponent("CheckMark")
  const _component_FieldLink = _resolveComponent("FieldLink")

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: {name:'home'} }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _createElementVNode("span", _hoisted_9, _toDisplayString($setup.lms_website.__('Student Applicant')), 1 /* TEXT */)
              ]),
              _createElementVNode("h3", _hoisted_10, _toDisplayString($setup.lms_website.__('Student Applicant')), 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              ($data.form.is_submitted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_CheckMark),
                    _createElementVNode("h3", _hoisted_17, _toDisplayString($setup.lms_website.__('Thank You For Submission')), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_18, _toDisplayString($setup.lms_website.__('We will review your application and send email if confirmed')), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              (!$data.form.is_submitted)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    method: "post",
                    class: _normalizeClass({'form-loading':($data.form.loading)}),
                    onSubmit: _cache[16] || (_cache[16] = $event => ($options.submitApplicant($event)))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: "section-title",
                        style: _normalizeStyle($options.sectionTitleStyle)
                      }, "Student Information - بيانات الطالب", 4 /* STYLE */),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm readonly-style",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.form.data.custom_application_date) = $event)),
                            readonly: "",
                            id: "custom_application_date",
                            placeholder: "",
                            required: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.form.data.custom_application_date]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["form-control form-control-sm", {'is-invalid': $data.validationErrors.first_name, 'is-valid': $data.form.data.first_name && !$data.validationErrors.first_name}]),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.form.data.first_name) = $event)),
                            id: "first_name",
                            style: {"direction":"rtl"},
                            placeholder: "",
                            onInput: _cache[2] || (_cache[2] = (...args) => ($options.validateArabicName && $options.validateArabicName(...args))),
                            required: ""
                          }, null, 34 /* CLASS, NEED_HYDRATION */), [
                            [_vModelText, $data.form.data.first_name]
                          ]),
                          ($data.validationErrors.first_name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($data.validationErrors.first_name), 1 /* TEXT */))
                            : ($data.form.data.first_name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString($setup.lms_website.__('Valid Arabic name')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.form.data.custom_name_in_english) = $event)),
                            id: "custom_name_in_english",
                            placeholder: "",
                            required: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.form.data.custom_name_in_english]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.form.data.student_email_id) = $event)),
                              id: "student_email_id",
                              placeholder: "name@example.com",
                              required: ""
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $data.form.data.student_email_id]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(["form-control form-control-sm", {
                            'is-invalid': $data.validationErrors.custom_other_mobile_number,
                            'is-valid': $data.form.data.custom_other_mobile_number && !$data.validationErrors.custom_other_mobile_number
                          }]),
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.form.data.custom_other_mobile_number) = $event)),
                              id: "custom_other_mobile_number",
                              placeholder: "01xxxxxxxxx",
                              onInput: _cache[6] || (_cache[6] = (...args) => ($options.validateOtherMobile && $options.validateOtherMobile(...args))),
                              maxlength: "11"
                            }, null, 34 /* CLASS, NEED_HYDRATION */), [
                              [_vModelText, $data.form.data.custom_other_mobile_number]
                            ])
                          ]),
                          ($data.validationErrors.custom_other_mobile_number)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString($data.validationErrors.custom_other_mobile_number), 1 /* TEXT */))
                            : ($data.form.data.custom_other_mobile_number)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString($setup.lms_website.__('Valid Egyptian mobile number')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(["form-control form-control-sm", {'is-invalid': $data.validationErrors.student_mobile_number, 'is-valid': $data.form.data.student_mobile_number && !$data.validationErrors.student_mobile_number}]),
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.form.data.student_mobile_number) = $event)),
                              id: "student_mobile_number",
                              placeholder: "01xxxxxxxxx",
                              onInput: _cache[8] || (_cache[8] = (...args) => ($options.validateEgyptianMobile && $options.validateEgyptianMobile(...args))),
                              maxlength: "11",
                              required: ""
                            }, null, 34 /* CLASS, NEED_HYDRATION */), [
                              [_vModelText, $data.form.data.student_mobile_number]
                            ])
                          ]),
                          ($data.validationErrors.student_mobile_number)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString($data.validationErrors.student_mobile_number), 1 /* TEXT */))
                            : ($data.form.data.student_mobile_number)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString($setup.lms_website.__('Valid Egyptian mobile number')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.form.data.custom_national_id) = $event)),
                            id: "custom_national_id",
                            placeholder: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.form.data.custom_national_id]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.form.data.custom_student_enrollment_code) = $event)),
                            id: "custom_student_enrollment_code",
                            placeholder: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.form.data.custom_student_enrollment_code]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", {
                        class: "section-title",
                        style: _normalizeStyle($options.sectionTitleStyle)
                      }, "Program Information - بيانات البرنامج", 4 /* STYLE */),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createCommentVNode(" Static: the program's Student Admission row defines the study type "),
                          ($data.studyTypeReadOnly)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString($data.form.data.custom_study_type), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" Editable: the admission row has no study type set "),
                                _createVNode(_component_FieldLink, {
                                  "model-value": $data.form.data,
                                  field: $data.form.link_fields.custom_study_type,
                                  "reference-doctype": "Study Type",
                                  "css-class": "form-control-sm",
                                  required: ""
                                }, null, 8 /* PROPS */, ["model-value", "field"])
                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _hoisted_55,
                          _createCommentVNode(" Read-only display when program is in URL "),
                          (_ctx.programReadOnly)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString($data.form.data.program), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" Editable FieldLink when no program in URL "),
                                _createVNode(_component_FieldLink, {
                                  "model-value": $data.form.data,
                                  field: $data.form.link_fields.program,
                                  "reference-doctype": "Program",
                                  page_length: "100",
                                  "css-class": "form-control-sm"
                                }, null, 8 /* PROPS */, ["model-value", "field"])
                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm readonly-style",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.form.data.custom_fee_amount) = $event)),
                            id: "custom_fee_amount",
                            placeholder: "",
                            readonly: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.form.data.custom_fee_amount]
                          ])
                        ]),
                        ($data.form.data.custom_branch_group_timetable)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "input-container timetable-table-container",
                              style: _normalizeStyle({ gridColumn: '1 / 4', gridRow: $data.showWaitingMonth ? 4 : 3 })
                            }, [
                              _hoisted_59,
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("table", _hoisted_61, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_62, [
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          disabled: "",
                                          checked: $data.form.data.custom_branch_group_timetable_days?.length
                                        }, null, 8 /* PROPS */, _hoisted_63)
                                      ]),
                                      _createElementVNode("th", _hoisted_64, _toDisplayString($setup.lms_website.__('Day')), 1 /* TEXT */),
                                      _createElementVNode("th", _hoisted_65, _toDisplayString($setup.lms_website.__('From')), 1 /* TEXT */),
                                      _createElementVNode("th", _hoisted_66, _toDisplayString($setup.lms_website.__('To')), 1 /* TEXT */)
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (!$data.form.data?.custom_branch_group_timetable_days?.length)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_67, [
                                          _createElementVNode("td", _hoisted_68, _toDisplayString($setup.lms_website.__('No Time Table Days')), 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.form.data?.custom_branch_group_timetable_days, (row) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: row.day
                                      }, [
                                        _createElementVNode("td", _hoisted_69, [
                                          _createElementVNode("input", {
                                            type: "checkbox",
                                            disabled: "",
                                            checked: $data.form.data.custom_branch_group_timetable_days?.length
                                          }, null, 8 /* PROPS */, _hoisted_70)
                                        ]),
                                        _createElementVNode("td", _hoisted_71, _toDisplayString(row.day), 1 /* TEXT */),
                                        _createElementVNode("td", _hoisted_72, _toDisplayString(row.from_time), 1 /* TEXT */),
                                        _createElementVNode("td", _hoisted_73, _toDisplayString(row.to_time), 1 /* TEXT */)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ])
                            ], 4 /* STYLE */))
                          : _createCommentVNode("v-if", true),
                        ($data.form.data.program)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "input-container courses-table-container",
                              style: _normalizeStyle({ gridColumn: '1 / 4', gridRow: $data.showWaitingMonth ? 5 : 4 })
                            }, [
                              _hoisted_74,
                              _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("table", _hoisted_76, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_77, [
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          disabled: "",
                                          checked: $data.form.data.custom_courses?.length
                                        }, null, 8 /* PROPS */, _hoisted_78)
                                      ]),
                                      _createElementVNode("th", _hoisted_79, _toDisplayString($setup.lms_website.__('No.')), 1 /* TEXT */),
                                      _createElementVNode("th", _hoisted_80, _toDisplayString($setup.lms_website.__('Course Name')), 1 /* TEXT */),
                                      _createElementVNode("th", _hoisted_81, _toDisplayString($setup.lms_website.__('Mandatory')), 1 /* TEXT */)
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (!$data.form.data?.custom_courses?.length)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_82, [
                                          _createElementVNode("td", _hoisted_83, _toDisplayString($setup.lms_website.__('No Courses To Apply')), 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.form.data?.custom_courses, (row, idx) => {
                                      return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_84, [
                                          _createElementVNode("input", {
                                            type: "checkbox",
                                            disabled: "",
                                            checked: $data.form.data.custom_courses?.length
                                          }, null, 8 /* PROPS */, _hoisted_85)
                                        ]),
                                        _createElementVNode("td", _hoisted_86, _toDisplayString(idx + 1), 1 /* TEXT */),
                                        _createElementVNode("td", _hoisted_87, _toDisplayString(row.course_name), 1 /* TEXT */),
                                        _createElementVNode("td", _hoisted_88, [
                                          _createElementVNode("input", {
                                            type: "checkbox",
                                            disabled: "",
                                            checked: row.required
                                          }, null, 8 /* PROPS */, _hoisted_89)
                                        ])
                                      ]))
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                  ])
                                ])
                              ])
                            ], 4 /* STYLE */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_90, [
                          _hoisted_91,
                          _createCommentVNode(" Static: the program's Student Admission row defines the branch "),
                          ($data.branchReadOnly)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString($data.form.data.custom_branch), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" Editable: the admission row has no branch set "),
                                _createVNode(_component_FieldLink, {
                                  "model-value": $data.form.data,
                                  field: $data.form.link_fields.custom_branch,
                                  "reference-doctype": "Cost Center",
                                  "css-class": "form-control-sm"
                                }, null, 8 /* PROPS */, ["model-value", "field"])
                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        ]),
                        ($data.form.data.custom_branch || $data.branchGroupTimetableReadOnly)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                              _hoisted_94,
                              _createCommentVNode(" Static: the program's Student Admission row defines the timetable "),
                              ($data.branchGroupTimetableReadOnly)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString($data.form.data.custom_branch_group_timetable), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" Editable: the admission row has no timetable set "),
                                    _createVNode(_component_FieldLink, {
                                      "model-value": $data.form.data,
                                      field: $data.form.link_fields.custom_branch_group_timetable,
                                      "reference-doctype": "Branch Group Timetable",
                                      "css-class": "form-control-sm"
                                    }, null, 8 /* PROPS */, ["model-value", "field"])
                                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Only for waiting groups (Branch Group Timetable.custom_waiting).\r\n                         Pinned directly under the timetable field, above both tables. "),
                        ($data.showWaitingMonth)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                              _hoisted_97,
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': $data.validationErrors.custom_waiting_month }]),
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.form.data.custom_waiting_month) = $event)),
                                id: "custom_waiting_month",
                                disabled: $data.waitingMonthReadOnly,
                                onChange: _cache[13] || (_cache[13] = (...args) => ($options.validateWaitingMonth && $options.validateWaitingMonth(...args)))
                              }, [
                                _hoisted_99,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.waitingMonthOptions, (month) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: month,
                                    value: month
                                  }, _toDisplayString(month), 9 /* TEXT, PROPS */, _hoisted_100))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_98), [
                                [_vModelSelect, $data.form.data.custom_waiting_month]
                              ]),
                              ($data.validationErrors.custom_waiting_month)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString($data.validationErrors.custom_waiting_month), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createCommentVNode(" <div v-if=\"form.error_message\" class=\"alert alert-danger mb-3\" role=\"alert\">\r\n                  {{ form.error_message }}\r\n                </div> "),
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            id: "infoCheckbox",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.form.data.terms_accepted) = $event)),
                            required: ""
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, $data.form.data.terms_accepted]
                          ]),
                          _createElementVNode("label", _hoisted_104, [
                            _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('أوافق على')), 1 /* TEXT */),
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[15] || (_cache[15] = _withModifiers($event => ($options.openTermsDialog('terms')), ["prevent"])),
                              class: "terms-link"
                            }, _toDisplayString($setup.lms_website.__(' الشروط وسياسة الخصوصية')), 1 /* TEXT */),
                            _hoisted_105
                          ])
                        ]),
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-primary",
                          disabled: $data.form.loading || !$options.isFormValid || !$data.form.data.terms_accepted
                        }, _toDisplayString($setup.lms_website.__('Submit Applicant')), 9 /* TEXT, PROPS */, _hoisted_106)
                      ])
                    ])
                  ], 34 /* CLASS, NEED_HYDRATION */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Terms Dialog "),
    _createVNode(_Transition, { name: "dialog-fade" }, {
      default: _withCtx(() => [
        ($data.showTermsDialog)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "terms-dialog-overlay",
              onClick: _cache[20] || (_cache[20] = _withModifiers((...args) => ($options.closeTermsDialog && $options.closeTermsDialog(...args)), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("h5", _hoisted_109, [
                    _hoisted_110,
                    _createTextVNode(" " + _toDisplayString($data.dialogTitle), 1 /* TEXT */)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "terms-dialog-close",
                    onClick: _cache[17] || (_cache[17] = (...args) => ($options.closeTermsDialog && $options.closeTermsDialog(...args)))
                  }, _hoisted_112)
                ]),
                _createElementVNode("div", {
                  class: "terms-dialog-body",
                  innerHTML: $data.termsContent
                }, null, 8 /* PROPS */, _hoisted_113),
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary btn-sm",
                    onClick: _cache[18] || (_cache[18] = (...args) => ($options.closeTermsDialog && $options.closeTermsDialog(...args)))
                  }, _toDisplayString($setup.lms_website.__('Close')), 1 /* TEXT */),
                  (!$data.form.data.terms_accepted)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[19] || (_cache[19] = (...args) => ($options.acceptAndClose && $options.acceptAndClose(...args)))
                      }, _toDisplayString($setup.lms_website.__('I Agree')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}